import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { YMark } from "@/components/site/Logo";

export default function AccountInvite() {
  const { token } = useParams();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [info, setInfo] = useState(null);
  const [missing, setMissing] = useState("");
  const [f, setF] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/account/invite/${token}`).then((r) => setInfo(r.data)).catch((e) => setMissing(formatApiError(e.response?.data?.detail)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (f.password !== f.confirm) return setError("Le due password non coincidono");
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/account/invite/${token}`, { password: f.password });
      setUser(data);
      navigate("/account");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const cls = "mt-2 w-full border-b border-[#1c1418]/30 bg-transparent py-3 text-lg outline-none focus:border-[#1c1418]";
  return (
    <main data-testid="account-invite-page" className="flex min-h-screen items-center justify-center bg-white px-5 pt-20 text-[#1c1418]">
      <div className="w-full max-w-md border border-[#1c1418]/20 p-8">
        <YMark className="h-12 w-12" />
        {missing ? (
          <div className="mt-6 space-y-6" data-testid="account-invite-invalid">
            <p className="font-display text-4xl uppercase leading-none">Link non valido</p>
            <p className="text-sm">{missing}</p>
            <Link to="/account" className="block w-full bg-[#1c1418] py-4 text-center font-mono text-xs uppercase tracking-[0.25em] text-white">Vai all'accesso</Link>
          </div>
        ) : info && (
          <form onSubmit={submit} className="mt-6 space-y-6">
            <h1 className="font-display text-5xl uppercase leading-none">Ciao {info.first_name}</h1>
            <p className="text-sm">Crea la password per la tua area. Accederai con <b data-testid="account-invite-email">{info.email}</b>.</p>
            {[["password", "Password (min 8)"], ["confirm", "Ripeti password"]].map(([k, l]) => (
              <label key={k} className="block font-mono text-[11px] uppercase tracking-[0.25em] text-[#1c1418]/70">{l}
                <input type="password" required minLength={8} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`account-invite-${k}`} className={cls} />
              </label>
            ))}
            {error && <p data-testid="account-invite-error" className="text-sm">{error}</p>}
            <button disabled={busy} data-testid="account-invite-submit" className="w-full bg-[#1c1418] py-4 font-mono text-xs uppercase tracking-[0.25em] text-white disabled:opacity-60">
              {busy ? "Salvataggio…" : "Crea password ed entra"}
            </button>
          </form>
        )}
      </div>
    </main>
  );
}
